<style scoped>
	.el-dialog__body {
		padding: 0 20px 20px 20px!important;
	}
	.form-line {
		display: flex;
		flex-direction: row;
		min-height: 50px;
		line-height: 30px;
		font-size: 16px;
		align-items: center;
	}
	.form-name {
		width: 100px;
		text-align: right;
	}
</style>
<template>
	<div>
		<div class="form-line">
			<div class="form-name">发送：</div>
			<div class="form-inp">{{info.uid}}&nbsp;&nbsp;<b>|</b>&nbsp;&nbsp;{{info.username}}&nbsp;&nbsp;<b>|</b>&nbsp;&nbsp;{{info.nickname}}</div>
		</div>
		<div class="form-line">
			<div class="form-name">标题：</div>
			<el-input v-model="form.title" placeholder="消息标题" style="width: 400px;"></el-input>
		</div>
		<div class="form-line">
			<div class="form-name">内容：</div>
			<quill-editor style="width: 400px;" v-model="form.content" :options="editorOption"></quill-editor>
		</div>
		<div class="form-line">
			<div class="form-name">秒数：</div>
			<el-input v-model="form.second" placeholder="消息标题" style="width: 400px;"></el-input>
		</div>
		<div class="form-line">
			<div class="form-name">设备：</div>
			<el-radio v-model="form.device" label="all">两端发送</el-radio>
			<el-radio v-model="form.device" label="mobile">手机端</el-radio>
			<el-radio v-model="form.device" label="pc">电脑端</el-radio>
		</div>
		<div class="form-line">
			<div class="form-name">保留：</div>
			<el-switch  v-model="form.retain"  active-color="#3399ff"  inactive-color="#CCCCCC"></el-switch>
		</div>
		<div class="form-line">
			<div class="form-name"></div>
			<el-button type="primary" style="width: 400px;" @click="submitSend()">立即推送</el-button>
		</div>
	</div>
</template>

<script>
	export default {
		props:['info'],
	    data() {
			return {
				editorOption: {
					placeholder: '请输入内容...',
					theme: 'snow', // 可选：'snow'（默认）, 'bubble'
					modules: {
						toolbar: [
							['bold', 'italic', 'underline', 'strike'], // 加粗、斜体、下划线、删除线
							['blockquote', 'code-block'],
							[{ header: 1 }, { header: 2 }],
							[{ list: 'ordered' }, { list: 'bullet' }],
							[{ script: 'sub' }, { script: 'super' }],
							[{ indent: '-1' }, { indent: '+1' }],
							[{ direction: 'rtl' }],
							[{ size: ['small', false, 'large', 'huge'] }],
							[{ header: [1, 2, 3, 4, 5, 6, false] }],
							[{ color: [] }, { background: [] }],
							[{ font: [] }],
							[{ align: [] }],
							['clean'], // 清除格式
							['link', 'image', 'video'] // 插入链接、图片、视频
						]
					}
				},
				form:{
					title:'通知',
					content:'',
					second:0,
					retain:false,
					device:'all',
					imid:'',
					uid:'',
				},
				rules: {
					title: [{required: true, message: '请输入帮助问题', trigger: 'blur'}],
					content: [{required: true, message: '请输入帮助内容', trigger: 'blur'}]
				},
				headers:{
					Authorization:'',
				}
	      };
	    },
		created() {
			this.headers.Authorization = localStorage.getItem('access_token');
			this.form.uid = this.info.uid;
			this.form.imid = this.info.imid;
		},
	    methods: {
			submitSend(){
				let _this = this;
				const loading = this.$loading({
						lock: true,
						text: '推送中',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.7)'
					});
				_this.$api.post("/Push/pushPerson", this.form).then(res=>{
					loading.close();
					if(res.code == 200)
					{
						_this.$message({
							 message: '推送成功~',
							 type: 'success',
						});
					}else{
						return _this.$message({
							 message: res.msg,
							 type: 'warning',
						});
					}
				}).catch(err=>{
					loading.close();
				});
			}
		}
	}
</script>
